import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import topIcon from "../assets/top_icon.png";
import useLanguage from "../utils/useLanguage";

export default function ScrollToTop({ sidebarExpanded }) {
  const [show, setShow] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { pathname } = useLocation();
  const { currentDirection } = useLanguage();

  const buttonPlace = currentDirection === "ltr" ? "left" : "right";
  const buttonOffset = isMobile ? "10px" : `${(sidebarExpanded ? 240 : 64) + 20}px`;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="scroll-to-top-container">
      {show && (
        <div
          className={`button ${buttonPlace}`}
          style={{ [buttonPlace]: buttonOffset}}
          onClick={scrollToTop}
        >
          <img src={topIcon} alt="Scroll to top" className="icon" />
        </div>
      )}
    </section>
  );
}
